// extracted by mini-css-extract-plugin
export var box = "_25-2";
export var checkboxControl = "_25-0";
export var checkboxRow = "_25-9";
export var checked = "_25-3";
export var descriptionSpacer = "_25-b";
export var disabled = "_25-4";
export var icon = "_25-7";
export var input = "_25-1";
export var labelSpacer = "_25-a";
export var medium = "_25-6";
export var small = "_25-5";
export var text = "_25-8";